import createPersistedState from 'use-persisted-state'

export default function usePersistedEventState(eventId, key, defaultValue) {
    return createPersistedState(`event.${eventId}.${key}`)(defaultValue);
}
